<template>
  <div class="about-story2">
    <div v-html="block.settings.story_paragraph2"></div>
  </div>
</template>

<script>
export default {
  name: 'AboutStory2',
  props: {
    block: Object
  }
}
</script>
<style lang="scss">
  .about-story2 {
    // max-width: 1243px;

    @include tablet-up {
    margin: 0px;

    }
    @include mobile-only {
    margin: 0px;

    }
  }
</style>